import { Injectable } from "@angular/core";
import { IconType } from "src/app/modules/authentication/components/models/authentication-actions.enum";

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  //#region private
  private _dialogVisible: boolean = false;
  private _content: string = '';
  private _header: string = '';
  private _iconType: IconType = IconType.Warning; // Default icon type (can be Success, Warning, Error)
  private _showConfirmButton: boolean = false;  // Whether to show the confirm button or not
  private _showCloseButton: boolean = true; // Default to true
  private _confirmAction: (() => void) | null = null;  // Function to be called on confirm
  //#endregion

  //#region setters

  public set showCloseButton(value: boolean) {
    this._showCloseButton = value;
  }

  public set dialogVisible(value: boolean) {
    this._dialogVisible = !!value;
  }

  public set content(value: string) {
    this._content = value;
  }

  public set header(value: string) {
    this._header = value;
  }

  public set iconType(value: IconType) {
    this._iconType = value;
  }

  public set showConfirmButton(value: boolean) {
    this._showConfirmButton = value;
  }

  public set confirmAction(action: (() => void) | null) {
    this._confirmAction = action;
  }
  //#endregion

  //#region getters

  public get showCloseButton(): boolean {
    return this._showCloseButton;
  }

  public get dialogVisible(): boolean {
    return this._dialogVisible;
  }

  public get content(): string {
    return this._content;
  }

  public get header(): string {
    return this._header;
  }

  public get iconType(): string {
    return this._iconType;
  }

  public get showConfirmButton(): boolean {
    return this._showConfirmButton;
  }

  public get confirmAction(): (() => void) | null {
    return this._confirmAction;
  }
  //#endregion

  //#region public actions
  public showDialog(title: string, content: string, iconType: IconType = IconType.Warning, showConfirmButton: boolean = false, confirmAction: (() => void) | null = null,showCloseButton: boolean = true): void {
    this.dialogVisible = true;
    this.header = title;
    this.content = content;
    this._iconType = iconType;
    this.showConfirmButton = showConfirmButton;
    this.showCloseButton = showCloseButton;
    this.confirmAction = confirmAction;
  }

  public hideDialog(): void {
    this.dialogVisible = false;
    this.header = '';
    this.content = '';
    this._iconType = IconType.Warning;
    this.showConfirmButton = false;
    this.confirmAction = null;
  }
  //#endregion
}
